export default (hashid) => {
  const url = `${process.env.API_LOCATION}/delivery_notes/${hashid}/?token=${localStorage.getItem('id_token')}`;
  window.open(url);
};



// WEBPACK FOOTER //
// ./src/app/services/invoice/showDeliveryNote.js